module.exports = __webpack_public_path__ + "static/media/sicepat.bc95a5b2.png";